import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  private readonly FIRST_NOTIFICATION_DELAY = 60000; // 1 minute in milliseconds
  private readonly NEXT_NOTIFICATIONS_INTERVAL = 900000; // 15 minutes in milliseconds
  private readonly STORAGE_KEY = 'isPushNotificationDismissed';
  
  private notificationSubject = new Subject<void>();
  
  public notification$: Observable<void> = this.notificationSubject.asObservable();
  
  private intervalSubscription: Subscription | null = null;
  private isActive = false;

  isInstalledAsPWA(): boolean {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }
    
    // ios check
    if ((window.navigator as any).standalone === true) {
      return true;
    }
    
    // fullscreen check
    if (window.matchMedia('(display-mode: fullscreen)').matches) {
      return true;
    }
    
    return false;
  }

  isDismissed(): boolean {
    if (typeof Storage === 'undefined') {
      return false;
    }

    return localStorage.getItem(this.STORAGE_KEY) === 'true';
  }

  markAsDismissed(): void {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    }
  }

  start(): void {
    if (this.isActive) {
      return;
    }
    
    this.isActive = true;
    
    this.intervalSubscription = timer(this.FIRST_NOTIFICATION_DELAY, this.NEXT_NOTIFICATIONS_INTERVAL)
      .subscribe(() => {
        this.notificationSubject.next();
      });
  }

  stop(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
    this.isActive = false;
  }

  get active(): boolean {
    return this.isActive;
  }
}
